module.exports = __webpack_public_path__ + "static/media/bottom-right.2e5c5dcc.svg";